import { createSlice } from "@reduxjs/toolkit";
import CryptoJS from "crypto-js";

let userData = {
  userEmail: "",
  token: "",
  id: "",
  role: "",
  challengeName:"",
  sessionToken:"",
  companyData:null,
  verificationStatus: null,
};
const initialAuthState = {
  user: {},
  isAuthenticated: false,
  token: "",
  role: "",
  rememberMeState: false,
  challengeName:"",
  sessionToken:""
};
let globalRememberMe = false;
const authSlice = createSlice({
  name: "auth",
  initialState: initialAuthState,
  reducers: {
    clickedRememberMe: (state, action) => {
      state.rememberMeState = action.payload;
      if (state.rememberMeState) {
        globalRememberMe = true;
      }
    },
    login(state, action) {
      state.isAuthenticated = true;
      state.user = action.payload.user;
      userData.userEmail = action.payload.email;
      state.role =CryptoJS.AES.encrypt(action.payload.role, '1-2').toString();
      userData.role =CryptoJS.AES.encrypt(action.payload.role, '1-2').toString();
      userData.token = action.payload.token;
      userData.id = action.payload.id;
      userData.challengeName = action.payload.challengeName;
      userData.sessionToken = action.payload.sessionToken;
      userData.companyData = action?.payload?.companyData
      userData.verificationStatus = action?.payload?.verificationStatus
      globalRememberMe
        ? localStorage.setItem("userData", JSON.stringify(userData))
        : sessionStorage.setItem("userData", JSON.stringify(userData));
    },

    
    logout(state) {
      state.isAuthenticated = false;
      state.role = "";
      let userDataFromStorageLocal = localStorage.getItem("userData") || "{}";
      userDataFromStorageLocal !== "{}"
        ? localStorage.removeItem("userData")
        : sessionStorage.removeItem("userData");
      globalRememberMe = false;
    },
  },
});

export default authSlice;
